// @flow

import CsvGenerator from "../CsvGenerator";
import global from "./Global";
import {asString, limit_timestamp} from "../util";
import Settings from "./Settings";
import type {ConvertedMeasurementType} from "../model";
import t from "../trans";
import Popup from "../Popup";


class ArchiveExport {
    isSimpleUi: boolean;
    showCenter: boolean;
    pointCount: number;
    addPoints: number;
    hudPoints: number;

    constructor() {
        let settings = Settings.getInstance();
        this.isSimpleUi = settings.isSimpleUi();
        this.showCenter = settings.showOnlyCenterPoints();
        this.pointCount = settings.getMeasurementLineCount()*3;
        this.addPoints = settings.getCenterAddPoints();
        this.hudPoints = settings.getHudPoints();
    }

    export(current?: ?boolean): void {
        let data = this.getArchiveSearchResults(current == null ? false : current);
        if (!data) {
            Popup.show_err(t("Data not found."));
            return;
        }

        let csv = new CsvGenerator(data, "export.csv");
        csv.download(true);
    }

    getArchiveSearchResults(current: boolean) {
        if (global.a_results == null) return null;

        let data: Array<Array<string>> = [];

        data.push(this.getSearchResultHeader());

        if (current) {
            if (global.a_measurement == null) return null;

            let r = global.a_measurement["rowNo"];
            if (r >= global.a_results.length) return null;

            let row = global.a_results[r];
            let drow = global.a_converted_results[r];
            let a = this.getSearchResultRow(row, drow);
            data.push(a);
        } else {
            for (let r = 0; r < global.a_results.length; r++) {
                let row = global.a_results[r];
                let drow = global.a_converted_results[r];
                let a = this.getSearchResultRow(row, drow);
                data.push(a);
            }
        }
        return data;
    }

    getSearchResultHeader(): Array<string> {
        let a;

        if (this.isSimpleUi) {
            a = [
                t("Skeleton no"),
                t("Time"),
                t("Product code"),
                t("Description")
            ];
        } else {
            a = [
                t("Wagon no"),
                t("Skeleton no"),
                t("Error code"),
                t("Time"),
                t("Product code"),
                t("Description")
            ];
        }
        // P1 - P9/15
        for (let i = 0; i < this.pointCount; i++) {
            a.push("P" + (i+1).toString());
        }

        // P300 - P50
        for (let k = this.addPoints-1; k >= 0; k--) {
            let pName = (k + 1) * 50;
            a.push("P" + pName.toString());
        }

        // ANGLE
        a.push(t("Angle"));

        // HUD1 - HUD5
        for (let i = 0; i < this.hudPoints; i++) {
            a.push("H" + (i+1).toString());
        }

        return a;
    }

    getSearchResultRow(row: MeasurementType, drow: ConvertedMeasurementType): ?Array<string> {
        let a = [];
        if (this.isSimpleUi) {
            a = [
                row.vaguni_raam,
                limit_timestamp(row.lopp_aeg),
                row.toote_variant,
                asString(row.kirjeldus1) + " " + asString(row.kirjeldus2)
            ];
        } else {
            a = [
                row.vaguni_number,
                row.vaguni_raam,
                row.veakood,
                limit_timestamp(row.lopp_aeg),
                row.toote_variant,
                asString(row.kirjeldus1) + " " + asString(row.kirjeldus2)
            ];
        }
        // P1 - P9/15
        for (let p = 0; p < this.pointCount; p++) {
            if (this.showCenter && (p % 3 != 1)) continue;
            a.push(this.getSearchResultPointCol(drow, p));
        }

        // P300 - P50
        for (let k = this.addPoints-1; k >= 0; k--) {
            a.push(this.getSearchResultPointCol(drow, this.pointCount+k));
        }

        // ANGLE
        let cvalue = "";
        if (drow.angles &&
            drow.angles.length > 0 &&
            drow.angles[0].length > 0 &&
            drow.angles[0][0] != null &&
            drow.analyzed_angles &&
            drow.analyzed_angles.length > 0) {
            // [diff, status, y]
            cvalue = ((Math.round(drow.analyzed_angles[0][2])) / 10).toString();
        }
        a.push(cvalue.replace(".", ","));

        // HUD1 - HUD5
        for (let k = 0; k < this.hudPoints; k++) {
            a.push(this.getSearchResultPointCol(drow, this.pointCount+this.addPoints+k));
        }

        return a;
    }

    getSearchResultPointCol(drow: ConvertedMeasurementType, p: number): string {
        let cvalue = "";
        if (drow.required &&
            drow.required[p] != null &&
            drow.required[p].length > 0 &&
            drow.required[p][0] != null &&
            drow.analyzed && drow.analyzed.length > p) {
            cvalue = drow.analyzed[p][2];
            cvalue = (Math.round(cvalue)) / 10;
            // AA: -100 is a result of missing data; TODO: raw data should be set null earlier
            if (cvalue == -100) cvalue = "";
        }
        cvalue = cvalue + "";
        return cvalue.replace(".", ",");
    }

}

export default ArchiveExport;
